import { render } from "./EchartView.vue?vue&type=template&id=36f1c8e8"
import script from "./EchartView.vue?vue&type=script&lang=js"
export * from "./EchartView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__